import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewApplicationLocationEcConstants } from "./view-application-location.ec.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import Polygon from "@arcgis/core/geometry/Polygon";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationLocationEcComponent = class ViewApplicationLocationEcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    // controls
    erfNoControl = ViewApplicationLocationEcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationEcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationEcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationEcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationEcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationEcConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationEcConstants.OWNER_CONTROL;
    buildingNameControl = ViewApplicationLocationEcConstants.BUILDING_NAME_CONTROL;
    floorControl = ViewApplicationLocationEcConstants.FLOOR_CONTROL;
    // Labels and placeholders
    descriptionLabel1 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationEcConstants.VALIDATION_MESSAGES;
    erfNoTextPlaceHolder = ViewApplicationLocationEcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationEcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationEcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationEcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationEcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationEcConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = ViewApplicationLocationEcConstants.OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationEcConstants.REMOVE_PROPERTY_LABEL;
    ownerListLabel = ViewApplicationLocationEcConstants.OWNER_LIST_LABEL;
    buildingNamePlaceHolder = ViewApplicationLocationEcConstants.BUILDING_NAME_LABEL;
    floorPlaceholder = ViewApplicationLocationEcConstants.FLOOR_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    ecApplication;
    propertiesForm;
    active;
    selectedApplicationECSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    ngOnInit() {
        this.ecApplication = this.selectedApplication;
        this.initForm();
        this.checkSave();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.ecApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber),
            subdivision: new FormControl(prop.subdivision),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom),
            buildingName: new FormControl(prop.buildingName, [Validators.required]),
            floor: new FormControl(prop.floor, [Validators.required]),
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.ecApplication.properties && this.ecApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        return propertyFoemGroup;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    handleRouteChange() {
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Electrical connection graphics", true);
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    checkSave() {
        this.selectedApplicationECSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            ;
            this.ecApplication = app;
            if (this.ecApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationEcComponent = __decorate([
    Component({
        selector: "app-view-application-location-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationEcComponent);
export { ViewApplicationLocationEcComponent };
